import { setVideoUploadIssueModal } from '../../../../../store/workspace/slice';
import { useDispatch } from '../../../../../store/store';
import Modal from '../../../../../components/Modal';
import styles from './style.module.scss';

export default function VideoUploadIssue() {
    const dispatch = useDispatch();
    const closeModal = () => dispatch(setVideoUploadIssueModal(false));

    return (
        <Modal
            size='sm'
            actions='confirm'
            closeFunc={closeModal}
            title='Video upload failed'
            childClassName={styles.wrapper}
            confirmButton={{
                text: 'Ok',
                type: 'Primary',
                onClick: closeModal,
            }}
        >
            <p>
                Video upload failed because the applicant disconnected,
                exited the exam, or withdrew video permission during the exam.
            </p>
        </Modal>
    );
};
